import React from 'react';
import { Field } from 'formik';
import { Label } from "../../ui/label.tsx";
import { Input } from "../../ui/input.tsx";
import { Textarea } from "../../ui/textarea.tsx";
import { Calendar } from "../../ui/calendar.tsx";

export const steps = [
  {
    name: "Basic Information",
    description: "Enter the employee's basic details",
    fields: ["firstName", "lastName", "email"]
  },
  {
    name: "Personal Details",
    description: "Enter personal information",
    fields: ["dob", "address"]
  }
];

const FormField = ({ field, label, type = "text", component = Input, ...props }) => (
  <div key={field} className="space-y-2">
    <Label htmlFor={field} className="text-sm font-medium">
      {label}
    </Label>
    <Field
      as={component}
      id={field}
      name={field}
      type={type}
      className="w-full"
      {...props}
    />
  </div>
);

export const renderFormStep = (currentStep, errors, touched, values, setFieldValue, isLoading) => {
  const { fields, description } = steps[currentStep - 1];

  return (
    <div className="space-y-6">
      {description && (
        <p className="text-sm text-muted-foreground">
          {description}
        </p>
      )}
      
      <div className="space-y-4">
        {fields.map((field) => {
          const hasError = errors[field] && touched[field];
          
          switch (field) {
            case "firstName":
              return (
                <div key={field}>
                  <FormField
                    field={field}
                    label="First Name"
                    placeholder="Enter first name"
                    disabled={isLoading}
                  />
                  {hasError && (
                    <div className="text-red-500 text-sm mt-1">{errors[field]}</div>
                  )}
                </div>
              );

            case "lastName":
              return (
                <div key={field}>
                  <FormField
                    field={field}
                    label="Last Name"
                    placeholder="Enter last name"
                    disabled={isLoading}
                  />
                  {hasError && (
                    <div className="text-red-500 text-sm mt-1">{errors[field]}</div>
                  )}
                </div>
              );

            case "email":
              return (
                <div key={field}>
                  <FormField
                    field={field}
                    label="Email Address"
                    type="email"
                    placeholder="Enter email address"
                    disabled={isLoading}
                  />
                  {hasError && (
                    <div className="text-red-500 text-sm mt-1">{errors[field]}</div>
                  )}
                </div>
              );

            case "dob":
              return (
                <div key={field}>
                  <Label className="text-sm font-medium">Date of Birth</Label>
                  <div className="mt-2">
                    <Calendar
                      mode="single"
                      selected={values.dob ? new Date(values.dob) : undefined}
                      onSelect={(date) => {
                        if (date) {
                          // Format date as ISO string
                          setFieldValue('dob', date.toISOString());
                        }
                      }}
                      disabled={(date) => {
                        // Disable future dates and dates less than 18 years ago
                        const today = new Date();
                        const minDate = new Date();
                        minDate.setFullYear(today.getFullYear() - 18);
                        return date > today || date > minDate;
                      }}
                      className="rounded-md border"
                    />
                  </div>
                  {hasError && (
                    <div className="text-red-500 text-sm mt-1">{errors[field]}</div>
                  )}
                </div>
              );

            case "address":
              return (
                <div key={field}>
                  <FormField
                    field={field}
                    label="Complete Address"
                    component={Textarea}
                    placeholder="Enter complete address"
                    disabled={isLoading}
                  />
                  {hasError && (
                    <div className="text-red-500 text-sm mt-1">{errors[field]}</div>
                  )}
                </div>
              );

            default:
              return null;
          }
        })}
      </div>
    </div>
  );
};
